import React, { useState } from 'react';
import Chart from 'react-apexcharts';

const DonutChart = ({data}) => {

    const [chartData, setChartData] = useState({
    series: data.chartValue, // Data values
    options: {
      chart: {
        type: 'donut',
        animations: {
          enabled: true, // Disable animations
        }
      },
      labels: data.chartLabel, // Categories
      colors: ['#41B06E', '#FF4560', "#246AFD", '#FF4545'], // Custom colors
      dataLabels: {
        enabled: false,
        formatter: (val, opts) => {
          return `${val.toFixed(1)}%`;
        },
        style: {
          fontSize: '12px',
          colors: ['#fff'],
        },
      },
      legend: {
        show: true,
        position: 'right',
        formatter: function (val, opts) {
          return val + ' - ' + opts.w.globals.series[opts.seriesIndex];
        }
      },
      plotOptions: {
        pie: {
          donut: {
            size: '70%',
            labels: {
              show: false,
              total: {
                show: false,
              },
            },
          },
        },
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val) => `${val}`,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 500,
            },
            legend: {
              show: false,
              position: 'bottom',
            },
          },
        },
      ],
    },
  });

  return (
    <div>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="donut"
        height={150}
      />
    </div>
  );
};

export default DonutChart;
